import { render, staticRenderFns } from "./deviations-list.vue?vue&type=template&id=291e2917&"
import script from "./deviations-list.vue?vue&type=script&lang=js&"
export * from "./deviations-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports